import {Routes} from '@angular/router';
import {FeatureFlagsEnum} from '@truelearn-web/shared/feature-flag';

import {curriculumGuard} from 'libs/curriculum/src/lib/guards/curriculum.guard';
import {FeatureFlagGuardFactory} from 'libs/shared/feature-flag/src/lib/guards/feature-flag.guard';
import {identityGuard} from 'libs/shared/service/src/lib/guards/main.guard';
import {PageNotFoundComponent} from 'libs/shared/ui/src/lib/components/page-not-found/page-not-found.component';
import {RedirectToPageComponent} from './components/redirect-to-page/redirect-to-page.component';

export const questionViewerParentRoute = 'question-viewer' as const;

export const mainRoutes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        component: RedirectToPageComponent // Don't delete the component — it's used to update data when the institution changes via router navigation
    },
    {
        path: 'inbox',
        data: {title: 'Inbox'},
        loadComponent: () =>
            import('libs/faculty-performance/src/lib/components/performance-inbox/performance-inbox-page/performance-inbox-page.component').then(
                (m) => m.PerformanceInboxPageComponent
            )
    },
    {
        path: 'performance',
        data: {title: 'Performance'},
        loadChildren: () =>
            import('libs/faculty-performance/src/lib/lib.routes').then((m) => m.facultyPerformanceRoutes)
    },
    {
        path: 'manage',
        loadChildren: () => import('libs/ioa/src/lib/app-routing.module').then((m) => m.ioaRoutes)
    },
    {
        path: 'manage/learners',
        loadChildren: () =>
            import('libs/faculty-learners/src/lib/faculty-learners.module').then((m) => m.facultyLearnersRoutes)
    },
    {
        path: 'manage/faculty',
        loadChildren: () =>
            import('libs/faculty-faculties/src/lib/faculty-faculties.module').then((m) => m.facultyFacultiesRoutes)
    },
    {
        path: 'manage/report',
        loadChildren: () => import('libs/faculty-report/src/lib/lib.routes').then((m) => m.facultyReportRoutes)
    },
    {
        path: 'manage/groups',
        loadChildren: () => import('libs/faculty-groups/src/lib/faculty-groups.module').then((m) => m.faculyGroupRoutes)
    },
    {
        path: 'manage/subscriptions',
        loadChildren: () =>
            import('libs/faculty-subscriptions/src/lib/lib.routes').then((m) => m.facultySubscriptionsRoutes)
    },
    {
        path: 'quizzes',
        data: {title: 'Quizzes'},
        loadChildren: () => import('libs/quizzes/src/lib/app-routing.module').then((m) => m.quizRoutes)
    },
    {
        path: 'curriculum',
        data: {title: 'Curriculum'},
        loadChildren: () => import('libs/curriculum/src/lib/curriculum-routing.module').then((m) => m.curriculumRoutes),
        canActivate: [identityGuard, curriculumGuard]
    },
    {
        path: 'assessments',
        data: {title: 'Assessments'},
        loadChildren: () => import('libs/assessments/src/lib/app-routing.module').then((m) => m.assessmentRoutes)
    },
    {
        path: questionViewerParentRoute,
        data: {title: 'Question Viewer'},
        canActivate: [identityGuard],
        loadChildren: () =>
            import('libs/question-viewer/feature/src/lib/question-viewer-feature.module').then(
                (m) => m.questionViewerFeatureRoutes
            ),
        outlet: 'fullscreen'
    },
    {
        path: 'report-viewer',
        data: {title: 'Quiz report viewer'},
        loadChildren: () => import('libs/report/src/lib/report-viewer.module').then((m) => m.reportRoutes),
        outlet: 'fullscreen'
    },
    {
        path: 'external',
        children: [
            {
                path: 'question-search/:externalSearchParameters',
                loadComponent: () =>
                    import('libs/standalone-question-search/feature/src/lib/components/external-standalone-question-search/external-standalone-question-search.component').then(
                        (m) => m.ExternalStandaloneQuestionSearchComponent
                    )
            },
            {
                path: 'performance',
                loadComponent: () =>
                    import('libs/faculty-performance/src/lib/components/performance-dashboard/external-performance-dashboard/external-performance-dashboard.component').then(
                        (m) => m.ExternalPerformanceDashboardComponent
                    )
            },
            {
                path: 'quizzes-list',
                loadComponent: () =>
                    import('libs/quizzes/src/lib/pages/quizzes/quizzes-list/external-quizzes-list/external-quizzes-list.component').then(
                        (m) => m.ExternalQuizzesListComponent
                    )
            }
        ]
    },
    {
        path: 'questions',
        data: {title: 'Questions'},
        loadChildren: () =>
            import('libs/standalone-question-search/feature/src/lib/standalone-question-search-feature.module').then(
                (m) => m.routes
            )
    },
    {
        path: 'content-library',
        data: {title: 'Content Library'},
        loadChildren: () => import('@truelearn-web/faculty-content-library').then((m) => m.facultyContentLibraryRoutes),
        canActivate: [
            FeatureFlagGuardFactory.create<boolean>(FeatureFlagsEnum.FACULTY_CONTENT_LIBRARY, (v) => !!v, '/')
        ]
    },
    {
        path: 'ai-tools',
        data: {title: 'AI Tools'},
        loadChildren: () => import('libs/faculty-ai/src/lib/lib.routes').then((m) => m.facultyAiRoutes)
    },
    {
        path: '**',
        pathMatch: 'full',
        component: PageNotFoundComponent,
        outlet: 'fullscreen'
    },
    {
        path: 'page-not-found',
        component: PageNotFoundComponent
    },
    {
        path: '**',
        pathMatch: 'full',
        redirectTo: '/page-not-found'
    }
];
